<template>
  <Progressbar v-if="loading" />
  <NetworkError v-else-if="errors" @tryAgain="getBugReport" />
  <div class="xl:w-6/12 2xl:w-4/12 h-full flex" v-else>
    <div class="card bg-white w-full my-auto">
      <div class="card-body flex flex-col justify-center items-center">
        <div class="alert alert-success" v-if="bug.success_message">{{ bug.success_message }}</div>
        <Form @submit="onSubmit" v-slot="{ errors }" class="w-full flex flex-col" v-else>
          <h6 class="card-title mt-4">{{ __('Please fill out the form below carefully') }}</h6>
          <small>{{ __('Your report helps us to provide better services to users') }}</small>
          <div class="form-control" v-for="field in bug.fields">
            <label class="label text-gray-300 dark:text-gray-200 text-sm" for="name">
              {{ field.placeholder }}
            </label>
            <Field as="select" class="select bg-blue-custom-1 text-blue-custom-2 placeholder-blue-custom-2"
              v-if="field.type === 'select'" :name="field.name" :rules="field.required ? 'required' : ''"
              v-model="formData[field.name]" :class="{ '!select-error': errors[field.name] }">
              <option v-for="option in field.options" :value="option">{{ option }}</option>
            </Field>
            <Field v-else :as="field.type === 'textarea' ? 'textarea' : 'input'"
              class="bg-blue-custom-1 text-blue-custom-2 placeholder-blue-custom-2"
              :class="{ 'checkbox': field.type === 'checkbox', 'input-error': errors[field.name], 'textarea-error': errors[field.name], 'input': ['text', 'email', 'phone', 'tel', 'url'].includes(field.type), 'textarea !h-28 max-h-28': field.type === 'textarea', 'file-input file-input-primary': field.type === 'file' }"
              :rules="field.required ? 'required' : ''" :placeholder="`${field.placeholder + ' ' + __('Enter yourself')}`"
              v-model="formData[field.name]" :name="field.name" accept=".jpg,.jpeg,.png,.zip,.rar" :type="field.type" />
            <label class="label" v-if="field.type == 'file'">
              <small>{{ __('Allowed extensions: jpg, jpeg, png, zip, rar') }}</small>
            </label>
          </div>
          <div class="form-control mt-4">
            <button type="submit" class="btn btn-primary">
              {{ __('Submit a report') }}
            </button>
          </div>
        </Form>
        <div class="mt-1">{{ __('Contact support') }}: <span style="unicode-bidi: embed;">{{ bug.contact }}</span></div>
      </div>
    </div>
  </div>
</template>
<script setup>
import useHome from "../../../composables/shop/home";
import { Field, Form } from "vee-validate";
import { onMounted } from "vue";
const { loading, errors, bug, getBugReport, sendForm, formData } = useHome();
const onSubmit = () => sendForm('bug');
onMounted(() => getBugReport());
</script>